import { render, staticRenderFns } from "./RightSetting.vue?vue&type=template&id=5464a5e7"
import script from "./RightSetting.vue?vue&type=script&lang=js"
export * from "./RightSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports